/** @internal */
export const OP_DONE = "Done";
/** @internal */
export const OP_AWAIT = "Await";
//# sourceMappingURL=channelMergeDecision.js.map